// extracted by mini-css-extract-plugin
export default {"logs-history":"History_logs-history__NlZJ-","logsContainer":"History_logsContainer__6rz1X","logItem":"History_logItem__2K+ZU"};